"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const themeContext_1 = require("./themeContext");
const ThemeProvider = ({ children, theme = 'modern', colorScheme = 'system', ...props }) => {
    const contextValue = (0, react_1.useMemo)(() => ({
        theme,
        colorScheme,
    }), [theme, colorScheme]);
    return ((0, jsx_runtime_1.jsx)(themeContext_1.ThemeContext.Provider, { value: contextValue, children: (0, jsx_runtime_1.jsx)("div", { "data-theme": theme, "data-color-scheme": colorScheme, ...props, children: children }) }));
};
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=themeProvider.js.map